import React from 'react';

const BookIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.5 5H20.5V22H6.5V5Z'
        stroke='#6B7280'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M17.5 5V2H4C3.86739 2 3.74021 2.05268 3.64645 2.14645C3.55268 2.24021 3.5 2.36739 3.5 2.5V19H6.5M10.5 11H16.5M10.5 15H16.5'
        stroke='#6B7280'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BookIcon;
